import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { useNavigate } from "react-router-dom";


function Checkout() {
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        country: "",
        state: "",
        address_line1: "",
        address_line2: "",
        postal_code: "",
        payment_method: "LC Bank Transfer",
    });

    const [loading, setLoading] = useState(false);
    const [cart, setCart] = useState(null); // Store cart data
    const [items, setItems] = useState([]); // Store cart items
    const [totalPrice, setTotalPrice] = useState(0); // Store total price
    const navigate = useNavigate();


    // ✅ Load Razorpay Script
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        script.onload = () => console.log("✅ Razorpay Script Loaded");
        document.body.appendChild(script);
    }, []);

    // ✅ Fetch Cart Details and Calculate Total Price
    useEffect(() => {
        const userId = localStorage.getItem("userId");
        if (!userId) {
            alert("User not logged in. Please log in.");
            return;
        }

        axios
            .get(`https://api.irfanelectricals.com/api/cart/${userId}`)
            .then((response) => {
                if (response.data.success) {
                    setCart(response.data.cart);
                    setItems(response.data.items);

                    // ✅ Calculate Total Price
                    const total = response.data.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
                    setTotalPrice(total);
                }
            })
            .catch((error) => {
                console.error("Error fetching cart:", error);
            });
    }, []);

    // ✅ Handle Input Change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // ✅ Handle Razorpay Payment
    const handleRazorpayPayment = async () => {
        try {
            const userId = localStorage.getItem("userId");
            if (!userId) {
                alert("User not logged in. Please log in.");
                return;
            }

            setLoading(true);

            // ✅ 1. Create Razorpay Order (Call Backend API)
            const response = await axios.post("https://api.irfanelectricals.com/api/razorpay/create-order", {
                user_id: userId,
                total_price: totalPrice, // Use the total price from state
            });

            if (!response.data.success || !response.data.order_id) {
                throw new Error("Failed to create Razorpay order.");
            }

            const orderId = response.data.order_id; // ✅ Get Razorpay Order ID

            // ✅ 2. Proceed with Razorpay Payment
            const options = {
                key: "rzp_live_MQUWuB98AZ6h4F", // Razorpay Key ID
                amount: totalPrice * 100, // Amount in paise
                currency: "USD",
                name: "Irfan Electricals",
                description: "Order Payment",
                order_id: orderId, // ✅ Attach generated order_id
                handler: async function (response) {
                    console.log("✅ Razorpay Response:", response);
                    await handleOrderCreation(orderId, response.razorpay_payment_id, response.razorpay_signature);
                },
                prefill: {
                    name: `${formData.first_name} ${formData.last_name}`,
                    email: formData.email,
                    contact: formData.phone,
                },
                theme: { color: "#3399cc" },
                method: {
                    netbanking: true,
                    card: true,
                    upi: true,
                    wallet: true,
                },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (error) {
            console.error("❌ Razorpay Payment Error:", error);
            alert("Payment failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // ✅ Handle Order Creation API Call
    const handleOrderCreation = async (razorpay_order_id = null, razorpay_payment_id = null, razorpay_signature = null) => {
        try {
            const userId = localStorage.getItem("userId");
            if (!userId) {
                alert("User not logged in. Please log in.");
                return;
            }

            setLoading(true);

            const orderData = {
                ...formData,
                user_id: userId,
                total_price: totalPrice,
                razorpay_order_id,
                razorpay_payment_id,
                razorpay_signature,
            };

            console.log("✅ Order Data Sent:", JSON.stringify(orderData, null, 2));

            const response = await axios.post("https://api.irfanelectricals.com/api/orders/create", orderData, {
                headers: { "Content-Type": "application/json" },
            });

            console.log("✅ Order Response:", response.data);

            if (response.data.success) {
                alert("Order placed successfully!");
                navigate("/profile"); // ✅ Redirect to Profile Page
            } else {
                throw new Error(response.data.message || "Order placement failed.");
            }
        } catch (error) {
            alert(error.response?.data?.message || "Failed to place order.");
            console.error("❌ Order Error:", error.response?.data || error.message);
        } finally {
            setLoading(false);
        }
    };

    // ✅ Handle Checkout Click
    const handleCheckout = () => {
        if (formData.payment_method === "Razorpay") {
            handleRazorpayPayment();
        } else {
            handleOrderCreation();
        }
    };

    return (
        <>
            <Navbar />
            <section id="checkout" className="p_3">
                <div className="container-xl">
                    <div className="checkout_1 row">
                        <div className="col-md-8">
                            <div className="checkout_1l">
                                <h5>Billing Details</h5>
                            </div>

                            {/* ✅ All Billing Fields Retained */}
                            <div className="row">
                                {["first_name", "last_name", "email", "phone", "country", "state", "address_line1", "address_line2", "postal_code"].map((field, index) => (
                                    <div key={index} className="col-md-6">
                                        <label>{field.replace("_", " ").toUpperCase()} *</label>
                                        <input type="text" className="form-control" name={field} value={formData[field]} onChange={handleChange} />
                                    </div>
                                ))}
                            </div>


                            {/* ✅ Payment Method Selection */}
                            <div className="checkout_1l">
                                <h5>PAYMENTS</h5>
                                <div>
                                    <input type="radio" name="payment_method" value="Razorpay" onChange={handleChange} /> Razorpay
                                    <input type="radio" name="payment_method" value="LC Bank Transfer" onChange={handleChange} defaultChecked /> LC Bank Transfer
                                </div>
                            </div>

                            <button onClick={handleCheckout} disabled={loading} style={{ marginTop: '20px', padding: '10px 20px', backgroundColor: '#3399cc', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                                {loading ? "Processing..." : "PROCEED TO CHECKOUT"}
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default Checkout;